/**
 * 防腐层类型定义
 * 统一封装API响应状态
 */

/**
 * 功能支持状态
 */
export enum FeatureStatus {
  /** ✅ 完全支持 - API已提供 */
  AVAILABLE = 'available',
  /** ⚠️ 降级可用 - 使用替代方案 */
  DEGRADED = 'degraded',
  /** 🚧 暂不支持 - 功能开发中 */
  UNAVAILABLE = 'unavailable',
}

/**
 * 适配器统一返回格式
 */
export interface AdapterResult<T> {
  /** 响应数据 */
  data: T;
  /** 功能状态 */
  status: FeatureStatus;
  /** 状态说明信息 */
  message?: string;
  /** 是否使用了降级方案 */
  fallback?: boolean;
}

/**
 * 功能开关配置
 * 用于控制各功能的实现方式
 */
export interface FeatureFlags {
  /** 是否有推荐位API */
  featuredAPI: boolean;
  /** 是否有搜索建议API */
  searchSuggestionsAPI: boolean;
  /** 是否有下载链接配置 */
  downloadLinks: boolean;
  /** 是否有用户系统 */
  userSystem: boolean;
  /** 是否支持历史同步 */
  historySync: boolean;
}

/**
 * 默认功能开关
 * 当前阶段：大部分功能使用降级方案
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  featuredAPI: false,
  searchSuggestionsAPI: false,
  downloadLinks: false,
  userSystem: false,
  historySync: false,
};

/**
 * 获取功能状态对应的显示文本
 */
export function getStatusText(status: FeatureStatus): string {
  switch (status) {
    case FeatureStatus.AVAILABLE:
      return '✅';
    case FeatureStatus.DEGRADED:
      return '⚠️';
    case FeatureStatus.UNAVAILABLE:
      return '🚧';
    default:
      return '';
  }
}

/**
 * 获取功能状态对应的说明
 */
export function getStatusDescription(status: FeatureStatus): string {
  switch (status) {
    case FeatureStatus.AVAILABLE:
      return '功能正常';
    case FeatureStatus.DEGRADED:
      return '使用替代方案';
    case FeatureStatus.UNAVAILABLE:
      return '功能开发中';
    default:
      return '';
  }
}
